
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4224_4582)"}},[_c('path',{attrs:{"d":"M2.5 8.334a6 6 0 0011.66 2m-11.66-2l2 1.333m-2-1.333l-1.333 2m13.334-2.667a6 6 0 00-11.659-2m11.659 2l-2-1.333m2 1.333l1.333-2","stroke":"currentColor","stroke-width":"1.44","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4224_4582"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    